import React, { useState } from 'react';
import { CommunicationHistoryTableContainer } from './CommunicationHistory/CommunicationHistoryTableContainer';
import { CommunicationSearch } from './CommunicationSearch/CommunicationSearch';

export const SearchCommunicationWrapper = ({ data = [] }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = e => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <>
      <CommunicationSearch
        searchTerm={searchTerm}
        handleChange={handleChange}
      />
      <CommunicationHistoryTableContainer data={data} searchTerm={searchTerm} />
    </>
  );
};
